import { type FC, useState } from 'react';
import { Eye, Pencil, Trash2, MoreVertical, Wallet } from 'lucide-react';
import { TableCell } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { OtroTramiteRecord } from '../types';

export interface OtrosTramiteActionsProps {
  tramite: OtroTramiteRecord;
  onView: (tramite: OtroTramiteRecord) => void;
  onEdit: (tramite: OtroTramiteRecord) => void;
  onDelete: (tramite: OtroTramiteRecord) => void;
  onManageCobros?: (tramite: OtroTramiteRecord) => void;
}

/** Menú de acciones del trámite; lo usan la fila de la tabla y la ficha móvil. */
export const OtrosTramiteActionsMenu: FC<OtrosTramiteActionsProps> = ({
  tramite,
  onView,
  onEdit,
  onDelete,
  onManageCobros,
}) => {
  const [open, setOpen] = useState(false);

  const handleAction = (callback: () => void) => {
    // Cerrar el dropdown primero
    setOpen(false);
    // Dar tiempo a que el dropdown se cierre antes de abrir el modal
    setTimeout(() => {
      callback();
    }, 100);
  };

  const hasMontos = tramite.montoARS > 0 || tramite.montoUSD > 0;

  return (
    <DropdownMenu open={open} onOpenChange={setOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0"
        >
          <MoreVertical className="h-4 w-4" />
          <span className="sr-only">Abrir menú de acciones</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => handleAction(() => onView(tramite))}>
          <Eye className="h-4 w-4" />
          Ver detalle
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => handleAction(() => onEdit(tramite))}>
          <Pencil className="h-4 w-4" />
          Editar
        </DropdownMenuItem>
        {hasMontos && onManageCobros && (
          <DropdownMenuItem onClick={() => handleAction(() => onManageCobros(tramite))}>
            <Wallet className="h-4 w-4" />
            Gestionar Cobros
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => handleAction(() => onDelete(tramite))}
        >
          <Trash2 className="h-4 w-4" />
          Eliminar
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

OtrosTramiteActionsMenu.displayName = 'OtrosTramiteActionsMenu';

export const OtrosTramiteActions: FC<OtrosTramiteActionsProps> = (props) => (
  <TableCell>
    <div className="flex justify-end">
      <OtrosTramiteActionsMenu {...props} />
    </div>
  </TableCell>
);

OtrosTramiteActions.displayName = 'OtrosTramiteActions';
